import * as types from '../../contactUs/constants/ActionTypes';

const initialState = {
  display: false,
  isLoading: false,
  error: false,
  article: undefined,
  relatedArticles: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_ARTICLE:
      return Object.assign({}, state, {
        isLoading: true,
        error: false,
        article: undefined,
        display: true,
      });

    case types.RECEIVE_ARTICLE_RESPONSE:
      return Object.assign({}, state, {
        isLoading: false,
        error: false,
        article: action.payload,
        relatedArticles: action.payload && action.payload.relatedArticles,
      });

    case types.RECEIVE_ARTICLE_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        error: true,
        article: undefined,
      });
    case types.RESET_RELATED_ARTICLE:
      return Object.assign({}, state, { relatedArticles: [] });
    default:
      return state;
  }
}
